module.exports = __webpack_public_path__ + "static/media/  (173).e80f224b.jpg";